import { FC, ReactElement } from 'react'
import cn from 'classnames'
import { ResponsiveImage } from 'common/components/ResponsiveImage'
import { Typography, TypographyVariants } from 'common/typography'
import styles from './styles.module.sass'

interface IEmptyContainerView {
  icon?: ReactElement;
  isLayoutView: boolean;
  title?: string;
  description?: string;
}

export const EmptyContainerView: FC<IEmptyContainerView> = ({
  icon, title, description, isLayoutView
}) => {
  return (
    <div className={cn(styles.emptyContainer, !isLayoutView && styles.emptyModalContainer)}>
      <ResponsiveImage icon={icon} />
      <div className={styles.emptyContainerText}>
        <Typography variant={TypographyVariants.Headings_H6_Medium} tag="p" className={styles.title}>
          {title}
        </Typography>
        <Typography variant={TypographyVariants.Body_1_Regular} tag="p" className={styles.description}>
          {description}
        </Typography>
      </div>
    </div>
  )
}
